import { EntityLayout } from '@backstage/plugin-catalog';
import {
  EntityTerraformContent,
  isTerraformAvailable
} from '@globallogicuki/backstage-plugin-terraform';
import { minimumOverviewContent } from './minimumOverviewContent';
import { techdocsContent } from './techdocsContent';
import { cicdContent, isCicdAvailable } from './cicdContent';

export type DefaultEntityPageProps = {
  overview?: React.JSX.Element;
  additionalRoutes?: React.JSX.Element;
}
export const defaultEntityPage = (props?:DefaultEntityPageProps) => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {props?.overview ?? minimumOverviewContent()}
    </EntityLayout.Route>

    <EntityLayout.Route path="/ci-cd" title="CI/CD" if={isCicdAvailable}>
      {cicdContent()}
    </EntityLayout.Route>

    {props?.additionalRoutes}

    <EntityLayout.Route path="/terraform" title="Terraform" if={isTerraformAvailable}>
      <EntityTerraformContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent()}
    </EntityLayout.Route>
  </EntityLayout>
);
